import {
  Application,
  ApplicationFilters,
  ApplicationResponse,
  ApplicationStatus,
  DecisionType,
  Applicant,
} from '../types/application';

import { IApplicationRepository } from './interfaces/IApplicationRepository';

const MOCK_APPLICANTS: Applicant[] = [
  {
    id: '1',
    name: 'Sarah Johnson',
    email: 'sarah.johnson@email.com',
    profileImage:
      'https://images.unsplash.com/photo-1494790108755-2616b613905b?w=100&h=100&fit=crop&crop=face',
    creditScore: 780,
    incomeRatio: 3.5,
    housingVerified: true,
    identityVerified: true,
    incomeVerified: true,
    createdAt: new Date('2023-06-15'),
    updatedAt: new Date('2023-06-15'),
  },
  {
    id: '2',
    name: 'Robert Chen',
    email: 'robert.chen@email.com',
    profileImage:
      'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
    creditScore: 720,
    incomeRatio: 4.1,
    housingVerified: false,
    identityVerified: true,
    incomeVerified: true,
    createdAt: new Date('2023-06-18'),
    updatedAt: new Date('2023-06-18'),
  },
  {
    id: '3',
    name: 'Michael Davis',
    email: 'michael.davis@email.com',
    profileImage:
      'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face',
    creditScore: 650,
    incomeRatio: 2.8,
    housingVerified: true,
    identityVerified: false,
    incomeVerified: true,
    createdAt: new Date('2023-06-20'),
    updatedAt: new Date('2023-06-20'),
  },
  {
    id: '4',
    name: 'James Wilson',
    email: 'james.wilson@email.com',
    profileImage:
      'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face',
    creditScore: 780,
    incomeRatio: 3.5,
    housingVerified: true,
    identityVerified: true,
    incomeVerified: false,
    createdAt: new Date('2023-06-10'),
    updatedAt: new Date('2023-06-10'),
  },
  {
    id: '5',
    name: 'Emily Rodriguez',
    email: 'emily.rodriguez@email.com',
    profileImage:
      'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face',
    creditScore: 780,
    incomeRatio: 3.5,
    housingVerified: true,
    identityVerified: true,
    incomeVerified: false,
    createdAt: new Date('2023-06-12'),
    updatedAt: new Date('2023-06-12'),
  },
  {
    id: '6',
    name: 'Jessica Thompson',
    email: 'jessica.thompson@email.com',
    profileImage:
      'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=face',
    creditScore: 810,
    incomeRatio: 4.2,
    housingVerified: true,
    identityVerified: true,
    incomeVerified: true,
    createdAt: new Date('2023-06-05'),
    updatedAt: new Date('2023-06-05'),
  },
  {
    id: '7',
    name: 'David Kim',
    email: 'david.kim@email.com',
    profileImage:
      'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=100&h=100&fit=crop&crop=face',
    creditScore: 810,
    incomeRatio: 4.2,
    housingVerified: true,
    identityVerified: true,
    incomeVerified: true,
    createdAt: new Date('2023-06-03'),
    updatedAt: new Date('2023-06-03'),
  },
];

const MOCK_APPLICATIONS: Application[] = [
  {
    id: '1',
    applicant: MOCK_APPLICANTS[0]!,
    listingId: '1',
    status: ApplicationStatus.NEW,
    decision: DecisionType.PENDING,
    appliedAt: new Date('2023-06-15T10:00:00Z'),
    createdAt: new Date('2023-06-15T10:00:00Z'),
    updatedAt: new Date('2023-06-15T10:00:00Z'),
  },
  {
    id: '2',
    applicant: MOCK_APPLICANTS[1]!,
    listingId: '1',
    status: ApplicationStatus.NEW,
    decision: DecisionType.PENDING,
    appliedAt: new Date('2023-06-18T14:30:00Z'),
    createdAt: new Date('2023-06-18T14:30:00Z'),
    updatedAt: new Date('2023-06-18T14:30:00Z'),
  },
  {
    id: '3',
    applicant: MOCK_APPLICANTS[2]!,
    listingId: '1',
    status: ApplicationStatus.NEW,
    decision: DecisionType.PENDING,
    appliedAt: new Date('2023-06-20T09:15:00Z'),
    createdAt: new Date('2023-06-20T09:15:00Z'),
    updatedAt: new Date('2023-06-20T09:15:00Z'),
  },
  {
    id: '4',
    applicant: MOCK_APPLICANTS[3]!,
    listingId: '1',
    status: ApplicationStatus.IN_REVIEW,
    decision: DecisionType.PENDING,
    appliedAt: new Date('2023-06-10T11:00:00Z'),
    reviewedAt: new Date('2023-06-11T09:00:00Z'),
    createdAt: new Date('2023-06-10T11:00:00Z'),
    updatedAt: new Date('2023-06-11T09:00:00Z'),
  },
  {
    id: '5',
    applicant: MOCK_APPLICANTS[4]!,
    listingId: '1',
    status: ApplicationStatus.IN_REVIEW,
    decision: DecisionType.PENDING,
    appliedAt: new Date('2023-06-12T16:45:00Z'),
    reviewedAt: new Date('2023-06-13T10:30:00Z'),
    createdAt: new Date('2023-06-12T16:45:00Z'),
    updatedAt: new Date('2023-06-13T10:30:00Z'),
  },
  {
    id: '6',
    applicant: MOCK_APPLICANTS[5]!,
    listingId: '1',
    status: ApplicationStatus.DECISION_MADE,
    decision: DecisionType.ACCEPTED,
    appliedAt: new Date('2023-06-05T13:20:00Z'),
    reviewedAt: new Date('2023-06-06T11:00:00Z'),
    decidedAt: new Date('2023-06-07T15:30:00Z'),
    createdAt: new Date('2023-06-05T13:20:00Z'),
    updatedAt: new Date('2023-06-07T15:30:00Z'),
  },
  {
    id: '7',
    applicant: MOCK_APPLICANTS[6]!,
    listingId: '1',
    status: ApplicationStatus.DECISION_MADE,
    decision: DecisionType.REJECTED,
    appliedAt: new Date('2023-06-03T08:00:00Z'),
    reviewedAt: new Date('2023-06-04T14:15:00Z'),
    decidedAt: new Date('2023-06-05T10:45:00Z'),
    createdAt: new Date('2023-06-03T08:00:00Z'),
    updatedAt: new Date('2023-06-05T10:45:00Z'),
  },
];

export class ApplicationRepository implements IApplicationRepository {
  private applications: Application[] = MOCK_APPLICATIONS;

  async getApplications(
    filters?: ApplicationFilters
  ): Promise<ApplicationResponse> {
    await new Promise(resolve => setTimeout(resolve, 100));

    let filteredApplications = this.applications;

    if (filters?.listingId) {
      filteredApplications = filteredApplications.filter(
        app => app.listingId === filters.listingId
      );
    }

    if (filters?.status) {
      filteredApplications = filteredApplications.filter(
        app => app.status === filters.status
      );
    }

    if (filters?.decision) {
      filteredApplications = filteredApplications.filter(
        app => app.decision === filters.decision
      );
    }

    const counts = this.calculateCounts(filteredApplications);

    return {
      applications: filteredApplications,
      counts,
    };
  }

  async getApplicationById(id: string): Promise<Application | null> {
    await new Promise(resolve => setTimeout(resolve, 50));

    const application = this.applications.find(app => app.id === id);
    return application || null;
  }

  async updateApplicationStatus(
    id: string,
    status: ApplicationStatus
  ): Promise<Application> {
    await new Promise(resolve => setTimeout(resolve, 150));

    const index = this.applications.findIndex(app => app.id === id);
    if (index === -1) {
      throw new Error('Application not found');
    }

    const current = this.applications[index]!;
    const now = new Date();

    const updatedApplication: Application = {
      ...current,
      status,
      updatedAt: now,
    };

    if (status === ApplicationStatus.IN_REVIEW && !current.reviewedAt) {
      updatedApplication.reviewedAt = now;
    }

    this.applications[index] = updatedApplication;
    return updatedApplication;
  }

  async makeDecision(id: string, decision: DecisionType): Promise<Application> {
    await new Promise(resolve => setTimeout(resolve, 200));

    const index = this.applications.findIndex(app => app.id === id);
    if (index === -1) {
      throw new Error('Application not found');
    }

    const current = this.applications[index]!;
    const now = new Date();

    const updatedApplication: Application = {
      ...current,
      status: ApplicationStatus.DECISION_MADE,
      decision,
      decidedAt: now,
      updatedAt: now,
    };

    if (!current.reviewedAt) {
      updatedApplication.reviewedAt = now;
    }

    this.applications[index] = updatedApplication;
    return updatedApplication;
  }

  async getApplicationsByListing(
    listingId: string
  ): Promise<ApplicationResponse> {
    return this.getApplications({ listingId });
  }

  private calculateCounts(applications: Application[]) {
    const counts = {
      new: 0,
      inReview: 0,
      decisionMade: 0,
      total: applications.length,
    };

    applications.forEach(app => {
      switch (app.status) {
        case ApplicationStatus.NEW:
          counts.new++;
          break;
        case ApplicationStatus.IN_REVIEW:
          counts.inReview++;
          break;
        case ApplicationStatus.DECISION_MADE:
          counts.decisionMade++;
          break;
      }
    });

    return counts;
  }
}

export const applicationRepository = new ApplicationRepository();
